import { useCallback, useEffect, useState } from 'react';
import {
  loadPolicyDetails,
  savePolicyDetails,
  type GenworthPolicyDetails,
} from './policy-details-storage';

const UPDATE_EVENT = 'genworth-policy-details-updated';

export function usePolicyDetails(clientId: string | undefined) {
  const [details, setDetails] = useState<GenworthPolicyDetails>(() =>
    clientId ? loadPolicyDetails(clientId) : {},
  );

  useEffect(() => {
    if (!clientId) return;

    setDetails(loadPolicyDetails(clientId));

    const handleUpdate = (event: Event) => {
      const { detail } = event as CustomEvent<{ clientId: string }>;

      if (detail?.clientId === clientId) {
        setDetails(loadPolicyDetails(clientId));
      }
    };
    window.addEventListener(UPDATE_EVENT, handleUpdate);
    return () => window.removeEventListener(UPDATE_EVENT, handleUpdate);
  }, [clientId]);

  const save = useCallback(
    (next: GenworthPolicyDetails) => {
      if (!clientId) return;

      savePolicyDetails(clientId, next);
      setDetails(next);

      window.dispatchEvent(new CustomEvent(UPDATE_EVENT, { detail: { clientId } }));
    },
    [clientId],
  );

  return { details, save };
}
